export default {
  instaSidebarWrapper: {
    width: (theme) => theme.customValues.taskSidebarWidth,
    minWidth: (theme) => theme.customValues.taskSidebarWidth,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
    '> *': { flexShrink: 0 },

    '@media (max-width: 760px)': {
      width: '100%',
      height: 'auto',
      overflow: 'visible',
      order: 2,
    },
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '4px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    color: (theme) => theme.palette.grays.gray700,
  },
  titleIcon: {
    display: 'inline-flex',
    color: (theme) => theme.palette.grays.gray700,
  },
  itemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    justifyContent: 'flex-start',
  },
  row: {
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
  },
  rowTitle: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: (theme) => theme.palette.grays.gray500,
  },
  copyValueWrapper: { display: 'flex', alignItems: 'center', gap: '8px' },
  divider: {
    borderColor: (theme) => theme.palette.grays.gray300,
    margin: '24px 0 0 0',
  },
};
